// Bulma's navbar burger toggles `is-active` on itself and on the menu named by
// its data-target. One delegated listener on the document covers every navbar
// the app ever renders, so Turbo replacing <body> never leaves the burger dead
// the way a per-element binding would.
document.addEventListener("click", (event) => {
  const burger = event.target.closest(".navbar-burger")
  if (!burger) return

  const menu = document.getElementById(burger.dataset.target)
  burger.classList.toggle("is-active")
  menu?.classList.toggle("is-active")
})
